import BenefitsTable from './BenefitsTable';

export default BenefitsTable;
